var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceitPheasant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85.19,
    height: 67.31,
    viewBox: "0 0 85.19 67.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome",
    x1: 415.77,
    y1: 96.74,
    x2: 415.77,
    y2: -92.14,
    gradientTransform: "matrix(0.36, 0, 0, -0.36, 0, 150.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ff6506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ff6e0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fe690c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#fd5e05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#fc5701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#fc5500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fe6300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6900"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "RGB_Pheasant") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M190.75,117a.6.6,0,0,0-1.11-.36c-10.37,15.93-16.21,25-21.48,33.29H106.33c-.78,0-1.07,1-.39,1.24,25.66,9.7,62.71,24.27,83.42,32.43.53.21,1.39-.28,1.39-.64V117Z",
    transform: "translate(-105.56 -116.36)",
    style: {
      fill: "url(#Sfumatura_senza_nome)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceitPheasant);
export default __webpack_public_path__ + "static/media/faceit-pheasant.97d64a33fd7d92af269c795f5eae04c7.svg";
export { ForwardRef as ReactComponent };